<template>
  <div class="flex">
    <sidebar :routes="sidebarRoutes" />
    <main-container>
      <router-view></router-view>
      <pagination-buttons :pages="pages"></pagination-buttons>
    </main-container>
  </div>
</template>

<script>
const Sidebar = () =>
  import(/* webpackChunkName: "SidebarComponent" */ "@/components/Global/Sidebar");
const MainContainer = () =>
  import(/* webpackChunkName: "MainContainerComponent" */ "@/components/Global/MainContainer.vue");
const PaginationButtons = () =>
  import(/* webpackChunkName: "PaginationButtons" */ "@/components/Global/PaginationButtons.vue");

export default {
  name: "Portfolio",
  components: {
    Sidebar,
    MainContainer,
    PaginationButtons
  },
  computed: {
    /*
     * @computed - pages
     * Array of pages href names that will be passed to pagination buttons component
     */
    pages() {
      const pages = [];

      this.sidebarRoutes.forEach(route => {
        if (route.children && !!route.children.length) {
          route.children.forEach(subRoute => pages.push(subRoute.href));
        } else {
          pages.push(route.href);
        }
      });

      return pages;
    },
    /*
     * @computed - sidebarRoutes
     * Data required for each route on the sidebar component
     */
    sidebarRoutes() {
      return [
        {
          description: this.$t("portfolio.neysla.pageLabel"),
          icon: ["fas", "code"],
          children: [
            {
              description: this.$t("portfolio.neysla.installation.pageLabel"),
              icon: ["fas", "dot-circle"],
              href: "NeyslaInstallation"
            },
            {
              description: this.$t("portfolio.neysla.directUsage.pageLabel"),
              icon: ["fas", "dot-circle"],
              href: "NeyslaDirectUsage"
            },
            {
              description: this.$t("portfolio.neysla.modelerUsage.pageLabel"),
              icon: ["fas", "dot-circle"],
              href: "NeyslaModelerUsage"
            }
          ]
        },
        {
          description: this.$t("portfolio.einaPage.pageLabel"),
          icon: ["fas", "code"],
          children: [
            {
              description: this.$t("portfolio.einaPage.installation.pageLabel"),
              icon: ["fas", "dot-circle"],
              href: "EinapageInstallation"
            },
            {
              description: this.$t("portfolio.einaPage.usage.pageLabel"),
              icon: ["fas", "dot-circle"],
              href: "EinapageUsage"
            }
          ]
        },
        {
          description: this.$t("portfolio.birthdayGift.pageLabel"),
          icon: ["fas", "code"],
          href: "BirthdayGift"
        },
        {
          description: this.$t("portfolio.weddingInvitation.pageLabel"),
          icon: ["fas", "code"],
          href: "WeddingInvitation"
        },
        {
          description: this.$t("portfolio.xterminate.pageLabel"),
          icon: ["fas", "code"],
          children: [
            {
              description: this.$t("portfolio.xterminate.instructions.pageLabel"),
              icon: ["fas", "dot-circle"],
              href: "XterminateInstructions"
            },
            {
              description: this.$t("portfolio.xterminate.play.pageLabel"),
              icon: ["fas", "dot-circle"],
              href: "XterminateGame"
            }
          ]
        },
        {
          description: this.$t("portfolio.memoram.pageLabel"),
          icon: ["fas", "code"],
          children: [
            {
              description: this.$t("portfolio.memoram.instructions.pageLabel"),
              icon: ["fas", "dot-circle"],
              href: "MemoramInstructions"
            },
            {
              description: this.$t("portfolio.memoram.play.pageLabel"),
              icon: ["fas", "dot-circle"],
              href: "MemoramGame"
            }
          ]
        },
        {
          description: this.$t("portfolio.baseballBate.pageLabel"),
          icon: ["fas", "code"],
          href: "BaseballBate"
        }
      ];
    }
  }
};
</script>
